import { toTitleCase } from "lib";

export const SplitOrigin = {
  BUYER: "Buyer",
  VENDOR: "Vendor",
};

export enum SplitType {
  HEADCOUNT = "HEADCOUNT",
  PERCENTAGE = "PERCENTAGE",
}

export const SplitTypeOptions = Object.entries(SplitType).map(
  ([label, value]) => ({
    label: toTitleCase(label),
    value,
  }),
);
